import type { AIMemoryObjectType } from "../../services/aiMemory/aiMemoryEndpoints.interface";

export type VectorObject = {
  slug: AIMemoryObjectType;
  name: string;
  description: string;
  icon: string;
  sources: string[]; // Provider display names, e.g. 'HubSpot'
  searchable_fields: string[];
  sample_data: string;
};

export const VECTOR_OBJECTS: VectorObject[] = [
  {
    slug: 'notes',
    name: 'Notes',
    description: 'CRM notes and customer interactions',
    icon: 'note',
    sources: ['HubSpot', 'Salesforce', 'Pipedrive'],
    searchable_fields: ['title', 'content_text', 'attachments_text'],
    sample_data: 'Meeting notes, call summaries, customer feedback',
  },
  {
    slug: 'conversation_messages',
    name: 'Conversation Messages',
    description: 'Email threads, chat messages, and support tickets',
    icon: 'message',
    sources: ['Intercom', 'Gmail', 'Outlook', 'Zendesk', 'Slack', 'HubSpot', 'Salesforce'],
    searchable_fields: ['message_text', 'attachments_text'],
    sample_data: 'Support tickets, customer emails, chat conversations',
  },
  {
    slug: 'tasks',
    name: 'Tasks',
    description: 'Action items and follow-up activities',
    icon: 'task',
    sources: ['HubSpot', 'Salesforce', 'Asana', 'Monday.com'],
    searchable_fields: ['subject', 'body_text'],
    sample_data: 'Follow-up tasks, reminders, action items',
  },
  {
    slug: 'deals',
    name: 'Deals',
    description: 'Deal information and opportunity summaries',
    icon: 'deal',
    sources: ['HubSpot', 'Salesforce', 'Pipedrive'],
    searchable_fields: ['name', 'description', 'deal_summary_md'],
    sample_data: 'Deal notes, opportunity summaries, close plans',
  },
  {
    slug: 'meetings',
    name: 'Meetings',
    description: 'Calendar meetings and agenda items',
    icon: 'calendar',
    sources: ['Google Calendar', 'Outlook', 'HubSpot'],
    searchable_fields: ['title', 'agenda_text'],
    sample_data: 'Meeting agendas, calendar events, scheduled calls',
  },
  {
    slug: 'meeting_recordings',
    name: 'Meeting Recordings',
    description: 'Transcripts and AI-generated meeting notes',
    icon: 'video',
    sources: ['Zoom', 'Google Meet', 'Fathom', 'Gong', 'Chorus'],
    searchable_fields: ['transcript_text', 'summary_md', 'action_items'],
    sample_data: 'Call transcripts, meeting summaries, extracted action items',
  },
  {
    slug: 'conversations',
    name: 'Conversations',
    description: 'Email threads and conversation containers',
    icon: 'chat',
    sources: ['Intercom', 'Zendesk', 'Gmail', 'Outlook'],
    searchable_fields: ['subject'],
    sample_data: 'Email thread subjects, ticket titles, conversation topics',
  },
];
